export const ACTION_PREFIX = 'TRUSTEE_DETAILS';

export const actionTypes = {
  UPDATE_INDIVIDUAL_TRUSTEE: 'UPDATE_INDIVIDUAL_TRUSTEE',
  UPDATE_TRUSTEE_VALIDATION_RESULT: 'UPDATE_TRUSTEE_VALIDATION_RESULT',
  RESET_TRUSTEE_VALIDATION_RESULT: 'RESET_TRUSTEE_VALIDATION_RESULT',
  UPDATE_TRUSTEE_NAMES: 'UPDATE_TRUSTEE_NAMES',
};

export const trusteeOptions = [
  { id: 'true', text: 'An Individual' },
  { id: 'false', text: 'A Company' },
];
